// step1.js - Updated with Australian date formatting

const Step1 = ({ reportData, handleInputChange, errors, authUser, username }) => {
      // Check if user is driddolls or driddolls_admin
      const canEditReferenceNo = username === 'driddolls' || username === 'driddolls_admin';
      
      // Function to format datetime for display in Australian format
      const formatAustralianDateTime = (dateString, timeString) => {
            if (!dateString || !timeString) return '';

            try {
                  const date = new Date(`${dateString}T${timeString}`);
                  const aestDate = new Date(date.toLocaleString("en-US", { timeZone: "Australia/Sydney" }));

                  const day = aestDate.getDate().toString().padStart(2, '0');
                  const month = (aestDate.getMonth() + 1).toString().padStart(2, '0');
                  const year = aestDate.getFullYear();
                  const hours = aestDate.getHours().toString().padStart(2, '0');
                  const minutes = aestDate.getMinutes().toString().padStart(2, '0');

                  return `${day}/${month}/${year}, ${hours}:${minutes}`;
            } catch (error) {
                  return `${dateString}, ${timeString}`;
            }
      };

      return (
            <>
                  {/* Reference No - Editable for driddolls and driddolls_admin */}
                  <div style={{ marginBottom: "2rem" }}>
                        <div style={{ position: "relative" }}>
                              <div style={{
                                    position: "absolute",
                                    top: "-0.6rem",
                                    left: "1rem",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    color: "#374151",
                                    backgroundColor: "rgba(255, 255, 255, 0.75)",
                                    padding: "0 0.25rem",
                                    borderRadius: "4px",
                                    zIndex: 1
                              }}>
                                    Reference No {canEditReferenceNo && <span style={{ color: "#0ea5a4", fontSize: "0.75rem" }}>(editable)</span>}
                              </div>
                              {canEditReferenceNo ? (
                                    <input
                                          type="text"
                                          value={reportData.referenceNo}
                                          onChange={e => handleInputChange("referenceNo", e.target.value)}
                                          placeholder=""
                                          style={{
                                                width: "100%",
                                                padding: "0.75rem 1rem",
                                                backgroundColor: "white",
                                                border: errors.referenceNo ? "1px solid #ef4444" : "1px solid #0ea5a4",
                                                borderRadius: "0.35rem",
                                                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                                fontSize: "0.85rem",
                                                outline: "none",
                                                transition: "all 0.2s ease",
                                                boxSizing: "border-box"
                                          }}
                                          onFocus={(e) => {
                                                e.target.style.borderColor = "#0ea5a4";
                                                e.target.style.boxShadow = "0 0 0 2px rgba(14, 165, 164, 0.2)";
                                          }}
                                          onBlur={(e) => {
                                                e.target.style.borderColor = errors.referenceNo ? "#ef4444" : "#0ea5a4";
                                                e.target.style.boxShadow = errors.referenceNo ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
                                          }}
                                    />
                              ) : (
                                    <div style={{
                                          fontSize: "0.85rem",
                                          color: "#64748b",
                                          backgroundColor: "#f8fafc",
                                          padding: "0.75rem 1rem",
                                          borderRadius: "0.35rem",
                                          border: "1px solid #d1d5db"
                                    }}>
                                          {reportData.referenceNo}
                                    </div>
                              )}
                        </div>
                        {errors.referenceNo && (
                              <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
                                    {errors.referenceNo}
                              </div>
                        )}
                  </div>


                  {/* Venue */}
                  <div style={{ marginBottom: "2rem" }}>
                        <div style={{ position: "relative" }}>
                              <div style={{
                                    position: "absolute",
                                    top: "-0.6rem",
                                    left: "1rem",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    color: "#374151",
                                    backgroundColor: "rgba(255, 255, 255, 0.75)",
                                    padding: "0 0.25rem",
                                    borderRadius: "4px",
                                    zIndex: 1
                              }}>
                                    Venue <span style={{ color: "#f97316" }}>*</span>
                              </div>
                              <select
                                    value={reportData.venue}
                                    onChange={e => handleInputChange("venue", e.target.value)}
                                    style={{
                                          width: "100%",
                                          padding: "0.75rem 1rem",
                                          backgroundColor: "white",
                                          border: errors.venue ? "1px solid #ef4444" : "1px solid #d1d5db",
                                          borderRadius: "0.35rem",
                                          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                          fontSize: "0.85rem",
                                          outline: "none",
                                          transition: "all 0.2s ease",
                                          boxSizing: "border-box"
                                    }}
                                    onFocus={(e) => {
                                          e.target.style.borderColor = "#0377fc";
                                          e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
                                    }}
                                    onBlur={(e) => {
                                          e.target.style.borderColor = errors.venue ? "#ef4444" : "#d1d5db";
                                          e.target.style.boxShadow = errors.venue ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
                                    }}
                              >
                                    <option value="">Select Venue</option>
                                    <option value="Adelaide Venue">Adelaide Venue</option>
                                    <option value="Brisbane Venue">Brisbane Venue</option>
                                    <option value="Campbelltown Sports Stadium">Campbelltown Sports Stadium</option>
                                    <option value="Coliseum Theatre">Coliseum Theatre</option>
                                    <option value="ENGIE Stadium">ENGIE Stadium</option>
                                    <option value="GMHBA Stadium at Kardinia Park">GMHBA Stadium at Kardinia Park</option>
                                    <option value="Jubilee Stadium">Jubilee Stadium</option>
                                    <option value="Hordern Pavilion">Hordern Pavilion</option>
                                    <option value="McDonald Jones Stadium">McDonald Jones Stadium</option>
                                    <option value="Melbourne Venue">Melbourne Venue</option>
                                    <option value="Perth Venue">Perth Venue</option>
                                    <option value="Qudos Bank Arena">Qudos Bank Arena</option>
                                    <option value="Sydney Olympic Park Aquatic Centre">Sydney Olympic Park Aquatic Centre</option>
                                    <option value="Sydney Olympic Park Athletic Centre">Sydney Olympic Park Athletic Centre</option>
                                    <option value="Sydney Olympic Park Quaycentre">Sydney Olympic Park Quaycentre</option>
                                    <option value="Sydney Olympic Park Precinct">Sydney Olympic Park Precinct</option>
                                    <option value="Sydney Showground">Sydney Showground</option>
                                    <option value="Sydney Venue">Sydney Venue</option>
                                    <option value="The Domain, Sydney">The Domain, Sydney</option>
                                    <option value="WIN Entertainment Centre">WIN Entertainment Centre</option>
                                    <option value="WIN Stadium">WIN Stadium</option>
                              </select>
                        </div>
                        {errors.venue && (
                              <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
                                    {errors.venue}
                              </div>
                        )}
                  </div>
                  {/* Event Name */}
                  <div style={{ marginBottom: "2rem" }}>
                        <div style={{ position: "relative" }}>
                              <div style={{
                                    position: "absolute",
                                    top: "-0.6rem",
                                    left: "1rem",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    color: "#374151",
                                    backgroundColor: "rgba(255, 255, 255, 0.75)",
                                    padding: "0 0.25rem",
                                    borderRadius: "4px",
                                    zIndex: 1
                              }}>
                                    Event Name <span style={{ color: "#f97316" }}>*</span>
                              </div>
                              <input
                                    type="text"
                                    value={reportData.eventName}
                                    onChange={e => handleInputChange("eventName", e.target.value)}
                                    placeholder=""
                                    style={{
                                          width: "100%",
                                          padding: "0.75rem 1rem",
                                          backgroundColor: "white",
                                          border: errors.eventName ? "1px solid #ef4444" : "1px solid #d1d5db",
                                          borderRadius: "0.35rem",
                                          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                          fontSize: "0.85rem",
                                          outline: "none",
                                          transition: "all 0.2s ease",
                                          boxSizing: "border-box"
                                    }}
                                    onFocus={(e) => {
                                          e.target.style.borderColor = "#0377fc";
                                          e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
                                    }}
                                    onBlur={(e) => {
                                          e.target.style.borderColor = errors.eventName ? "#ef4444" : "#d1d5db";
                                          e.target.style.boxShadow = errors.eventName ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
                                    }}
                              />
                        </div>
                        {errors.eventName && (
                              <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
                                    {errors.eventName}
                              </div>
                        )}
                  </div>

                  {/* Report Completed By - Section Header */}
                  <div style={{
                        marginBottom: "1rem",
                        fontSize: "0.85rem",
                        fontWeight: "500",
                        color: "#374151"
                  }}>
                        Completed By
                  </div>

                  {/* First Name and Last Name - side by side */}
                  <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "1.5rem",
                        marginBottom: "2rem"
                  }}>
                        {/* First Name */}
                        <div>
                              <div style={{ position: "relative" }}>
                                    <div style={{
                                          position: "absolute",
                                          top: "-0.6rem",
                                          left: "1rem",
                                          fontSize: "0.85rem",
                                          fontWeight: 500,
                                          color: "#374151",
                                          backgroundColor: "rgba(255, 255, 255, 0.75)",
                                          padding: "0 0.25rem",
                                          borderRadius: "4px",
                                          zIndex: 1
                                    }}>
                                          First Name <span style={{ color: "#f97316" }}>*</span>
                                    </div>
                                    <input
                                          type="text"
                                          value={reportData.reportCompletedBy.firstName}
                                          onChange={e => handleInputChange("reportCompletedBy.firstName", e.target.value)}
                                          placeholder=""
                                          style={{
                                                width: "100%",
                                                padding: "0.75rem 1rem",
                                                backgroundColor: "white",
                                                border: errors["reportCompletedBy.firstName"] ? "1px solid #ef4444" : "1px solid #d1d5db",
                                                borderRadius: "0.35rem",
                                                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                                fontSize: "0.85rem",
                                                outline: "none",
                                                transition: "all 0.2s ease",
                                                boxSizing: "border-box"
                                          }}
                                          onFocus={(e) => {
                                                e.target.style.borderColor = "#0377fc";
                                                e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
                                          }}
                                          onBlur={(e) => {
                                                e.target.style.borderColor = errors["reportCompletedBy.firstName"] ? "#ef4444" : "#d1d5db";
                                                e.target.style.boxShadow = errors["reportCompletedBy.firstName"] ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
                                          }}
                                    />
                              </div>
                              {errors["reportCompletedBy.firstName"] && (
                                    <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
                                          {errors["reportCompletedBy.firstName"]}
                                    </div>
                              )}
                        </div>

                        {/* Last Name */}
                        <div>
                              <div style={{ position: "relative" }}>
                                    <div style={{
                                          position: "absolute",
                                          top: "-0.6rem",
                                          left: "1rem",
                                          fontSize: "0.85rem",
                                          fontWeight: 500,
                                          color: "#374151",
                                          backgroundColor: "rgba(255, 255, 255, 0.75)",
                                          padding: "0 0.25rem",
                                          borderRadius: "4px",
                                          zIndex: 1
                                    }}>
                                          Last Name <span style={{ color: "#f97316" }}>*</span>
                                    </div>
                                    <input
                                          type="text"
                                          value={reportData.reportCompletedBy.lastName}
                                          onChange={e => handleInputChange("reportCompletedBy.lastName", e.target.value)}
                                          placeholder=""
                                          style={{
                                                width: "100%",
                                                padding: "0.75rem 1rem",
                                                backgroundColor: "white",
                                                border: errors["reportCompletedBy.lastName"] ? "1px solid #ef4444" : "1px solid #d1d5db",
                                                borderRadius: "0.35rem",
                                                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                                fontSize: "0.85rem",
                                                outline: "none",
                                                transition: "all 0.2s ease",
                                                boxSizing: "border-box"
                                          }}
                                          onFocus={(e) => {
                                                e.target.style.borderColor = "#0377fc";
                                                e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
                                          }}
                                          onBlur={(e) => {
                                                e.target.style.borderColor = errors["reportCompletedBy.lastName"] ? "#ef4444" : "#d1d5db";
                                                e.target.style.boxShadow = errors["reportCompletedBy.lastName"] ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
                                          }}
                                    />
                              </div>
                              {errors["reportCompletedBy.lastName"] && (
                                    <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
                                          {errors["reportCompletedBy.lastName"]}
                                    </div>
                              )}
                        </div>
                  </div>

                  {/* Position */}
                  <div style={{ marginBottom: "2rem" }}>
                        <div style={{ position: "relative" }}>
                              <div style={{
                                    position: "absolute",
                                    top: "-0.6rem",
                                    left: "1rem",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    color: "#374151",
                                    backgroundColor: "rgba(255, 255, 255, 0.75)",
                                    padding: "0 0.25rem",
                                    borderRadius: "4px",
                                    zIndex: 1
                              }}>
                                    Position <span style={{ color: "#f97316" }}>*</span>
                              </div>
                              <input
                                    type="text"
                                    value={reportData.position}
                                    onChange={e => handleInputChange("position", e.target.value)}
                                    placeholder=""
                                    style={{
                                          width: "100%",
                                          padding: "0.75rem 1rem",
                                          backgroundColor: "white",
                                          border: errors.position ? "1px solid #ef4444" : "1px solid #d1d5db",
                                          borderRadius: "0.35rem",
                                          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                          fontSize: "0.85rem",
                                          outline: "none",
                                          transition: "all 0.2s ease",
                                          boxSizing: "border-box"
                                    }}
                                    onFocus={(e) => {
                                          e.target.style.borderColor = "#0377fc";
                                          e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
                                    }}
                                    onBlur={(e) => {
                                          e.target.style.borderColor = errors.position ? "#ef4444" : "#d1d5db";
                                          e.target.style.boxShadow = errors.position ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
                                    }}
                              />
                        </div>
                        {errors.position && (
                              <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
                                    {errors.position}
                              </div>
                        )}
                  </div>

                  {/* Report Started - Display in Australian format */}
                  <div style={{ marginBottom: "2rem" }}>
                        <div style={{ position: "relative" }}>
                              <div style={{
                                    position: "absolute",
                                    top: "-0.6rem",
                                    left: "1rem",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    color: "#374151",
                                    backgroundColor: "rgba(255, 255, 255, 0.75)",
                                    padding: "0 0.25rem",
                                    borderRadius: "4px",
                                    zIndex: 1
                              }}>
                                    Report Started <span style={{ color: "#f97316" }}>*</span>
                              </div>

                              {/* Display formatted Australian date/time but use hidden input for actual form value */}
                              <div style={{
                                    fontSize: "0.85rem",
                                    color: "#374151",
                                    backgroundColor: "#f8fafc",
                                    padding: "0.75rem 1rem",
                                    borderRadius: "0.35rem",
                                    border: errors.reportStarted ? "1px solid #ef4444" : "1px solid #d1d5db"
                              }}>
                                    {formatAustralianDateTime(reportData.reportStarted, reportData.reportStartedTime)}
                              </div>

                              {/* Hidden input to maintain the actual form value */}
                              <input
                                    type="hidden"
                                    value={`${reportData.reportStarted}T${reportData.reportStartedTime}`}
                                    onChange={e => {
                                          const [date, time] = e.target.value.split("T");
                                          handleInputChange("reportStarted", date);
                                          handleInputChange("reportStartedTime", time);
                                    }}
                              />
                        </div>
                        {errors.reportStarted && (
                              <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
                                    {errors.reportStarted}
                              </div>
                        )}
                  </div>
            </>
      );
};

export default Step1;